export default "__VITE_ASSET__DRKrLA1h__"